import {
  CLEAR_SETTINGS_SECTIONS,
  SET_ACTIVE_SECTION_ID,
  SET_SETTINGS_CONTEXT,
  SET_SETTINGS_SECTIONS,
} from '@sophocles/features/navigation/settingsNavActions';

const initialState = {
  sections: [], // Array of { id, title } for sidebar rendering
  activeSectionId: null, // Currently active section
  settingsContext: null, // { context: 'customer'|'siteGroup'|'site', basePath: string } or null
};

function settingsNavReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SETTINGS_SECTIONS:
      return { ...state, sections: action.sections };
    case CLEAR_SETTINGS_SECTIONS:
      return { ...initialState, settingsContext: state.settingsContext };
    case SET_ACTIVE_SECTION_ID:
      return { ...state, activeSectionId: action.sectionId };
    case SET_SETTINGS_CONTEXT:
      return { ...state, settingsContext: action.settingsContext };
    default:
      return state;
  }
}

export default settingsNavReducer;
